import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TableSortUpIcon = createIcon({
    viewBox: '0 0 20 20',
    path: <Path d='M10.5 6L5 12H16L10.5 6Z' fill='currentColor' />,
})

TableSortUpIcon.displayName = 'TableSortUpIcon'
